<template>
<div class="col-12 text-left">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="p-2">
      <small class="text-muted">Report Expenses</small>
  </h3>
  <div class="p-2 dropdown-divider"></div>
  <div class="row">
    <div class="form-group col-3">
      <label for="subject">Start Date</label>
      <flat-pickr style="background-color:white;" class="form-control" v-model="reportExpense.startDate" ></flat-pickr>
    </div>
    <div class="form-group col-3">
      <label for="subject">To Date</label>
      <flat-pickr style="background-color:white;" class="form-control" v-model="reportExpense.toDate"></flat-pickr>
    </div>
    <div class="form-group col-3">
    <label for="uom">Expense Type</label>
    <app-lookup-field :model="reportExpense" :element="expenseLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
  </div>
  </div>
  <br /><br />
  <button type="button" class="btn btn-outline-success" @click="print">Print <i class="far fa-save"></i></button>
  <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
  </div>
</div>
</template>

<script>
import api from '../../services/api'
import { reportExpense } from '../../models/report'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        reportExpense: {...reportExpense},
        expenseLookup: {
          id: 'expense',
          title: 'Expense List',
          type: 'form',
          apiUrl: 'expense-list',
          filter: ['name'],
          fields: [
            {
                placeholder: 'Expense',
                width: 12,
                column: 'expensesName'
            }
          ],
          dtElements: [
            {
              title: 'Expense Name',
              column: 'name'
            },
            {
              title: 'Expense Category',
              column: 'category'
            },
            {
              title: 'Expense Remarks',
              column: 'remarks'
            },
          ],
          affectedField: [
            {
              from: 'id',
              to: 'expenseId'
            },
            {
              from: 'name',
              to: 'expensesName'
            }
          ]
        },
      }
    },
    async created() {

    },
    methods: {
    async print() {
      const rptApi = api('print/report-expense')
      const query = { 
        params: {
          startDate: this.reportExpense.startDate,
          toDate: this.reportExpense.toDate,
          expenseId: this.reportExpense.expenseId
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'Report-Expense.xlsx')
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
      const currentExpense = this.reportExpense
      this.reportExpense = {
          ...currentExpense,
          ...data
      }
    },
    finishUpload(data) {
      const currentExpense = this.reportExpense
      this.reportExpense = {
        ...currentExpense,
        ...data
      }
    },
    }
}
</script>